<template>
  <div id="sidenav" class="sidenav text-end">
    <optional-router-link idPosition="dashboard" to="home">Accueil
      <i class="fa fa-fw fa-home"></i> 
    </optional-router-link>

    <optional-router-link idPosition="category" to="categories" :disabled="!isGrantedAdmin">Catégories
      <i class="fa fa-fw fa-tags"></i> 
    </optional-router-link>

    <optional-router-link idPosition="product" to="products" :disabled="!isGrantedAdmin && !isGrantedManager">Produits
      <i class="fa fa-fw fa-lemon-o"></i>
    </optional-router-link>
    
    <optional-router-link idPosition="formules" to="menus" :disabled="!isGrantedAdmin && !isGrantedManager">Formules
      <i class="fa fa-fw fa-cutlery"></i> 
    </optional-router-link>
    
    <optional-router-link idPosition="formule_niveau" to="menus-parts" :disabled="!isGrantedAdmin && !isGrantedManager">Niveaux formules
      <i class="fa fa-fw fa-cutlery"></i>
    </optional-router-link>
    
    <optional-router-link idPosition="commandes" to="orders" :disabled="!isGrantedAdmin && !isGrantedManager">Commandes
      <i class="fa fa-fw fa-university"></i> 
    </optional-router-link>
    
    <optional-router-link idPosition="clients"  to="clients" :disabled="!isGrantedAdmin">Clients
      <i class="fa fa-fw fa-users"></i>
    </optional-router-link>
    
    <optional-router-link idPosition="outlet" to="outlets" :disabled="!isGrantedAdmin && !isGrantedManager">Points de ventes 
      <i class="fa fa-fw fa-map-marker"></i>
    </optional-router-link>
    
    <optional-router-link idPosition="users" to="users" :disabled="!isGrantedAdmin">Utilisateurs 
      <i class="fa fa-fw fa-user"></i>
    </optional-router-link>
  </div>
</template>
<script>

import {mapActions, mapState, mapGetters} from "vuex";
import OptionalRouterLink from "@/core/components/OptionalRouterLink";

export default {
  name: 'Sidebar',
  components:{
    OptionalRouterLink
  },
  computed:{
    ...mapState('auth',['fullUser','apiRslt']),
    ...mapGetters('auth',['isGrantedAdmin','isGrantedManager']),
  },
  methods:{
    ...mapActions('auth',['setFullUser'])
  },
  created() {
    this.setFullUser()
  }
}
</script>

<style scoped>
/*** Zone de test  */
/** Mobile */
@media screen and (max-width: 768px){
 #sidenav a {
  margin-top: 50%;
 }
}
/** Tablet */
@media screen and (max-width: 1020px) and (min-width: 768px){
  #sidenav a {
    margin-top: 25%;
  }
}
/** Laptop */
@media screen and (min-width: 1020px){
  #sidenav a {
    margin-top: 10%;
  }
}

.fa {
  padding-left: 6px;
}
#sidenav a {
  z-index: 1040;
  position: fixed;
  left: -137px;
  transition: 0.3s;
  padding: 15px;
  width: 175px;
  text-decoration: none;
  font-size: 15px;
  color: white;
  border-radius: 0 5px 5px 0;
}
#sidenav a:hover {
  left: 0;
}
#dashboard {
  top: -40px;
  background-color: #4e73df;
}
#category {
  top: 20px;
  background-color: #4e73df;
}
#product {
  top: 80px;
  background-color: #4e73df;
}
#formules {
  top: 140px;
  background-color: #4e73df;
}
#formule_niveau {
  top: 200px;
  background-color: #4e73df;
}
#commandes {
  top: 260px;
  background-color: #4e73df
}
#clients {
  top: 320px;
  background-color: #4e73df
}
#outlet {
  top: 380px;
  background-color: #4e73df
}
#users {
  top: 440px;
  background-color: #4e73df
}
/*** ********** */

</style>
